import * as React from 'react'
import { ReactElement } from 'react'
import { Label, Stack, StackItem } from '@fluentui/react'
import LegacyLocalDatePicker from '../LegacyLocalDatePicker'

type Props = {
    startValue: string
    endValue: string
    changeStartDate: (date: string) => void
    changeEndDate: (date: string) => void
    showLabel: boolean
}

export default function DateRange(props: Props): ReactElement {
    return (
        <>
            {props.showLabel && <Label>Datum van - tot</Label>}
            <Stack horizontal tokens={{ childrenGap: 's1' }} grow>
                <StackItem grow>
                    <LegacyLocalDatePicker
                        value={props.startValue}
                        onSelectDate={props.changeStartDate}
                        datePickerProps={{
                            label: undefined,
                            maxDate: new Date(props.endValue),
                            isRequired: false,
                        }}
                    />
                </StackItem>
                <StackItem grow>
                    <LegacyLocalDatePicker
                        value={props.endValue}
                        onSelectDate={props.changeEndDate}
                        datePickerProps={{
                            label: undefined,
                            minDate: new Date(props.startValue),
                            isRequired: false,
                        }}
                    />
                </StackItem>
            </Stack>
        </>
    )
}
